import * as Yup from "yup";

import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@material-ui/core";
import { Field, Form, Formik } from 'formik';
import { createPrfcs, fetchPrfcs } from '../../../services/prfcsService'
import { useMutation, useQuery } from "react-query";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog"
import { Autocomplete as FormikAutocomplete } from 'formik-material-ui-lab';
import { TextField as FormikTextField } from 'formik-material-ui';
import { fetchPrfcsTypes } from '../../../services/prfcsTypeService'
import useLocale from "../../../hooks/useLocale";
import { useState } from "react";

const CreateDialog = ({ open, close, refetch }) => {
  const { data: prfcsTypes } = useQuery('prfcsTypes', fetchPrfcsTypes);
  const { data: prfcs } = useQuery('prfcs', fetchPrfcs);
  const [error, setError] = useState('');
  const { t } = useLocale();
  // Mutation for creating data
  const { mutate } = useMutation(createPrfcs, {
    onSuccess: data => {
      refetch();
      close();
    },
    onError: error => {
      switch (error) {
        default: {
          setError(t('A network error occured. Please try again later'))
        }
      }
    }
  });

  const validationSchema = Yup.object().shape({
    dscr: Yup.string()
      .required(t('Field is required'))
      .max(256, t('Too long')),
    full_dscr: Yup.string()
      .required(t('Field is required'))
      .max(1000, t('Too long')),
    type_id: Yup.number()
      .nullable()
      .required(t('Field is required')),
  })

  const handleCreateItem = (values) => {
    mutate({ items: JSON.stringify([values]) });
  }

  return (
    <CustomDialog
      open={open}
      maxWidth='sm'
      onClose={close}
    >
      <DialogTitle id="form-dialog-title">{t('Add new Geographical Department')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('Fill in the form below and click on Add to add a new Geographical Department')}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => { setError('') }}
        message={t('A network error occured, please try again later')}
      />
      <Formik
        initialValues={{
          dscr: '',
          full_dscr: '',
          type_id: '',
          parent_id: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleCreateItem(values);
          setSubmitting(false);
        }}
      >
        {({ submitForm, isSubmitting, touched, errors, setFieldValue, values }) => (
          <Form>
            <DialogContent>
              <Field
                name='dscr'
                margin='normal'
                component={FormikTextField}
                fullWidth
                label={t('Description')}
              />
              <Field
                name='full_dscr'
                margin='normal'
                variant='outlined'
                component={FormikTextField}
                multiline
                rows={6}
                fullWidth
                label={t('Full Description')}
              />

              <Field
                name="type_id_select"
                component={FormikAutocomplete}
                options={prfcsTypes}
                onChange={(event, newValue) => {
                  setFieldValue('type_id', newValue?.id || '');
                }}
                getOptionLabel={(option) => option.dscr}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name='type_id'
                    error={touched['type_id'] && !!errors['type_id']}
                    helperText={touched['type_id'] && errors['type_id']}
                    label={t('Geographical Department Type')}
                    variant="outlined"
                    margin='normal'
                  />
                )}
              />



              <Field
                name='parent_id_select'
                component={FormikAutocomplete}
                onChange={(event, newValue) => {
                  setFieldValue('parent_id', newValue?.id);
                }}
                options={prfcs}
                getOptionLabel={(options) => options?.dscr || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name='parent_id'
                    error={touched['parent_id'] && !!errors['parent_id']}
                    helperText={touched['parent_id'] && errors['parent_id']}
                    label={t('Parent Geographical Department')}
                    variant="outlined"
                    margin='normal'
                  />
                )}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={submitForm} color="primary">
                {t('Add')}
              </Button>
              <Button onClick={close} color="primary">
                {t('Cancel')}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>

    </CustomDialog>
  )
}

export default CreateDialog;